import { Table, Pagination, Row } from "react-bootstrap";

const DataTable = ({
  data,
  columns,
  totalPages,
  onPageChange,
  // onSearch,
  // onSort,
  currentPage,
  // onItemsPerPageChange,
  isShowPagination = true,
}: any) => {
  // const [search, setSearch] = useState("");
  // const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  // const [itemsPerPage, setItemsPerPage] = useState(2);

  // const handleSearchChange = (event: any) => {
  //   const value = event.target.value;
  //   setSearch(value);
  //   onSearch(value); // call parent search function.
  // };

  const handlePageChange = (page: number) => {
    onPageChange(page); // call parent page change function.
  };

  // const handleSort = (key: string) => {
  //   const newDirection =
  //     sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
  //   setSortConfig({ key, direction: newDirection });
  //   onSort(key, newDirection); // call parent sort function.
  // };

  // const renderSortIcon = (key: string) => {
  //   if (sortConfig.key === key) {
  //     return sortConfig.direction === "asc" ? <FaSortUp /> : <FaSortDown />;
  //   }
  //   return <FaSort />;
  // };

  // const handleItemsPerPageChange = (event: any) => {
  //   const value = parseInt(event.target.value, 10);
  //   // setItemsPerPage(value);
  //   onItemsPerPageChange(value);
  // };

  return (
    <div>
      <Row className="mb-3">
        {/* <Col>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={search}
              onChange={handleSearchChange}
            />
          </InputGroup>
        </Col> */}
        {/* <Col xs="auto">
          <Form.Select value={itemsPerPage} onChange={handleItemsPerPageChange}>
            <option value={5}>5 items per page</option>
            <option value={10}>10 items per page</option>
            <option value={20}>20 items per page</option>
            <option value={50}>50 items per page</option>
          </Form.Select>
        </Col> */}
      </Row>
      <div className="appliedJobsTable">
        <div className="table-responsive">
          <Table striped bordered hover>
            <thead>
              <tr>
                {columns &&
                  columns?.map((column: any) => (
                    // <th key={column.key} onClick={() => handleSort(column.key)}>
                    <th key={column.key}>
                      {/* {column.label} {renderSortIcon(column.key)} */}
                      {column.label}
                    </th>
                  ))}
                {/* <th>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {data &&
                data?.map((row: any, index: number) => (
                  <tr key={index}>
                    {columns &&
                      columns?.map((column: any) => (
                        <td key={column.key}>{row[column.key]}</td>
                      ))}
                    {/* <td>
                <Button
                  variant="info"
                  size="sm"
                  className="me-2"
                  onClick={() => onView(row)}
                >
                  <FaEye />
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => onDelete(row)}
                >
                  <FaTrash />
                </Button>
              </td> */}
                  </tr>
                ))}
              {data?.length === 0 && (
                <tr>
                  <td colSpan={columns.length} className="text-center">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {isShowPagination && data?.length > 0 && totalPages > 1 && (
        <div className="pagination-holder">
          <Pagination>
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
              disabled={currentPage === 1}
            />
            {Array.from({ length: totalPages }, (_, i) => (
              <Pagination.Item
                key={i}
                active={i + 1 === currentPage}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() =>
                handlePageChange(Math.min(currentPage + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            />
            <Pagination.Last
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        </div>
      )}
    </div>
  );
};

export default DataTable;
